module.exports = __webpack_public_path__ + "static/img/callbackpictop.887b4ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/callback/callbackpictop.png
// module id = aG54
// module chunks = 0